export interface InternalUserExperiment {
  group: string
  name: string
}

const isInExperiment = (
  userExperimentsArray: InternalUserExperiment[] = [],
  experimentName: string,
  experimentGroup = 'experiment'
) =>
  userExperimentsArray.some(
    (experiment: InternalUserExperiment) =>
      experiment.name === experimentName && experiment.group === experimentGroup
  )

export default isInExperiment
